(function () {
  let debounceTimer = null;

  function formatMoney(cents) {
    const amount = cents / 100;
    return '$' + (amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2));
  }

  function updateBar(cart) {
    const bar = document.getElementById('cart-discount-progress');
    if (!bar || !cart) return;

    // 🔑 CART EMPTY CONDITION
    const isEmpty = cart.item_count === 0;

    // Apply styles ONLY when cart is empty
    bar.classList.toggle('cart-empty', isEmpty);

    // If you want the bar logic to stop when empty, uncomment this:
    // if (isEmpty) return;

    let tiers;
    try {
      tiers = JSON.parse(bar.dataset.tiers || '[]');
    } catch {
      return;
    }

    // Shopify subtotal (before discounts & shipping)
    const total = cart.items_subtotal_price || 0;

    const text = bar.querySelector('.progress-text');
    const fill = bar.querySelector('.progress-fill');
    if (!text || !fill) return;

    let currentIndex = -1;
    tiers.forEach((tier, i) => {
      if (total >= tier.spend) currentIndex = i;
    });

    const current = tiers[currentIndex];
    const next = tiers[currentIndex + 1];

    let message = '';

    if (current) {
      message += `🎉 You unlocked <strong>${formatMoney(current.discount)} OFF</strong>`;
    }

    if (current && next) {
      message += ' - ';
    }

    if (next) {
      const remaining = Math.max(next.spend - total, 0);
      message += `Spend <strong>${formatMoney(remaining)}</strong> more to unlock <strong>${formatMoney(next.discount)} OFF</strong>`;
    }

    text.innerHTML = message;

    let percent = 100;
    if (!current && next) {
      percent = (total / next.spend) * 100;
    } else if (current && next) {
      percent =
        ((total - current.spend) /
          (next.spend - current.spend)) *
        100;
    }

    fill.style.width = Math.min(Math.max(percent, 0), 100) + '%';
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(updateBar)
      .catch(() => {});
  }

  function debouncedRefresh() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(refreshCart, 150);
  }

  // Observe DOM changes (cart drawer re-render, bar added, etc.)
  const observer = new MutationObserver(() => {
    const bar = document.getElementById('cart-discount-progress');
    if (bar) debouncedRefresh();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();